import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const DonorDetailLayout = lazy(
  () => import('@/pages/donor-detail/ui/DonorDetailPage'),
)

export const Route = createFileRoute(
  '/_protected/labarotaroyResearch/$visitId',
)({
  component: LaboratoryResearchDetailRoute,
})

function LaboratoryResearchDetailRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <DonorDetailLayout visitId={visitId} basePath="/labarotaroyResearch" />
    </Suspense>
  )
}
